import React, { useEffect, useState, useContext } from 'react'
import { Button, Col, Divider, Drawer, Input, message, Row, Typography, Checkbox } from 'antd'
import Utils from '../../../../utils/Utils'
import GenericSelect from '../../../../components/GenericSelect'
import { Context } from '../../../../context'

const { Title } = Typography

function DiscountDrawer(props) {
  const [{ auth }] = useContext(Context)
  const [discountLevel, setDiscountLevel] = useState('')
  const [applyAll, setApplyAll] = useState(false)
  const [discountPercentage, setDiscountPercentage] = useState(0)
  const [enterprises, setEnterprises] = useState([])
  const [company_id, setCompanyId] = useState('')
  
  useEffect(() => {
    setDiscountLevel(props.edit ? props.editData.discount_level : '')
    setCompanyId(props.edit ? props.editData.company_id : null)
    onSearchEnterprise(props.edit ? props.editData.company_name : '')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible])

  const onSearchEnterprise = val => {
    val !== null ? (val = '') : (val = '')

    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getEnterpriseOption(val, excludeChars, 'desc')
      .then(response => {
        if (auth?.role?.id === 1) {
          response.data.data[response.data.data.length] = { id: 0, name: 'Señor tendero'}
        }
        setEnterprises(response.data.data)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de empresa')
      })
  }

  const onSave = () => {
    let data = {
      company_id: company_id,
      discount_level: discountLevel,
    }

    let msn = Utils.isEmpty(data)
    if (msn) {
      return message.error(` Todos los campos son Obligatorios`)
    }

    data['apply_discount_percentage_all_presentations'] = applyAll
    data['discount_amount'] = discountPercentage
    props.saveButton(props.edit, data, props.edit ? props.editData.id : null)
    setDiscountLevel('')
    setApplyAll(false)
    setDiscountPercentage(0)
  }

  const onCancel = () => {
    props.cancelButton()
    setDiscountLevel('')
    setApplyAll(false)
    setDiscountPercentage(0)
  }

  const onClose = () => {
    props.closable()
    setDiscountLevel('')
    setApplyAll(false)
    setDiscountPercentage(0)
  }

  return (
    <>
      <Drawer placement="right" closable={false} className={'assign-prices'} onClose={onClose} visible={props.visible} width={800}>
        <div className={'products-container-tabs'}>
          <Title> {props.edit ? 'Editar nivel' : 'Nuevo nivel'} </Title>
          <Divider className={'divider-custom-margins-users'} />
          <Row gutter={16} className={'section-space-field'}>
            <Col xs={24} sm={24} md={24} lg={24}>
              <div className={'title-space-field'}>Nivel de descuento</div>
              <Input
                value={discountLevel}
                onChange={value => setDiscountLevel(value.target.value)}
                placeholder={'Nombre del nivel de descuento'}
                size={'large'}
              />
            </Col>
          </Row>

          <Row gutter={16} className={'section-space-field'}>
            <Col xs={8} sm={8} md={8} lg={8}>
              <GenericSelect
                title={'Empresa*'}
                data={enterprises}
                value={(props.edit || company_id !== '') && company_id !== 0 ? company_id : company_id === 0 ? 'Señor Tendero' : ''}
                handlerChange={value => setCompanyId(value)}
                placeholder={'Elegir Empresa'}
                disabled={props.edit || !enterprises}
                optionLabel={props.edit && props.editData?.enterprises?.name}
              />
            </Col>
          </Row>

          <Row gutter={16} className={'section-space-field'}>
            <Col className={'checkbox'} xs={2} sm={2} md={2} lg={2}>
              <Checkbox checked={applyAll} onChange={e => setApplyAll(e.target.checked)}></Checkbox>
            </Col>
            <Col xs={14} sm={14} md={14} lg={14}>
              <div className={'title-space-field bold black'} style={{ fontSize: 'small' }}>¿Deseas aplicar el mismo porcentaje de descuento a todas tus presentaciones?</div>
              <div className={'title-space-field bottom'} style={{ fontSize: 'small' }}>Aplica únicamente para presentaciones ya existentes</div>
            </Col>
            <Col className={'checkbox'} xs={6} sm={6} md={6} lg={6}>
              <Input
                disabled={!applyAll}
                value={discountPercentage}
                onChange={e => setDiscountPercentage(e.target.value)}
                placeholder={'% de descuento'}
                size={'large'}
              />
            </Col>
          </Row>

        </div>
        <div>
          <Divider className={'divider-custom-margins-users'} />
          {/*Footer buttons section*/}
          <Row gutter={16}>
            <Col xs={24} sm={24} md={24} lg={24}>
              <div className="text-right">
                <div>
                  <Button type={'link'} className="cancel-button" onClick={() => onCancel()}>
                    Cancelar
                  </Button>
                  <Button htmlType="submit" className="title-tendero new-button" onClick={() => onSave()}>
                    Guardar
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
          {/*End Footer buttons section*/}
        </div>
      </Drawer>
    </>
  )
}

export default DiscountDrawer
